export class BucketFileProbeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lastModified",
            "baseName": "lastModified",
            "type": "string",
            "format": ""
        },
        {
            "name": "detectedFormat",
            "baseName": "detectedFormat",
            "type": "BucketFileFormat",
            "format": ""
        },
        {
            "name": "detectedCompression",
            "baseName": "detectedCompression",
            "type": "BucketFileCompression",
            "format": ""
        },
        {
            "name": "recordCountEstimate",
            "baseName": "recordCountEstimate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sampleRecords",
            "baseName": "sampleRecords",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "inferredFields",
            "baseName": "inferredFields",
            "type": "Array<JsonPathSample>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BucketFileProbeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
